import { isTouchDevice } from '../../utilities/utils';

export default class EagerlyImageMove {
  constructor(root: HTMLDivElement) {
    this.el = root;

    const handleMouseMove = (event: MouseEvent) => {
      root.style.cssText = `
        --pos-x: ${event.offsetX};
        --pos-y: ${event.offsetY};
      `;
    };

    const registerEventListeners = () => {
      // skip on touch devices
      if (!root || isTouchDevice()) return;

      root.addEventListener('mousemove', handleMouseMove);
    };

    registerEventListeners();

    // Don't re-instantiate over an existing one
    if (EagerlyImageMove.instances.has(this.el)) return;

    this.init();
  }

  el: HTMLDivElement;

  static instances = new WeakMap();

  init() {
    // Save a reference to the instance, so we know this DOM node has already been instancied
    EagerlyImageMove.instances.set(this.el, this);
  }

  /**
   * Delete EagerlyImageMove instance from DOM element
   */
  unmount() {
    EagerlyImageMove.instances.delete(this.el);
  }
}
